import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';

import { UsersListParams, UsersListResponse } from '@apis/usersApi.types';
import { $httpRootApi } from '@core/http-client';
import { usersActions } from '@redux/reducers/common/users/usersReducer';
import { getDefaultError, getQueriesAsSearch } from '@shared/utils/common';

export const getUsersList = (params: UsersListParams) => {
  return $httpRootApi.get<UsersListResponse>(`/users${getQueriesAsSearch(params)}`);
};

export function* getUsersSaga(action: PayloadAction<UsersListParams>) {
  try {
    yield put(usersActions.setUsersLoading(true));
    const { data } = yield call(() => getUsersList(action.payload));

    yield put(usersActions.getUserSuccess(data));
  } catch (e) {
    yield put(usersActions.getUsersFailure(getDefaultError(e?.response?.data?.message)));
  }
}
